/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Scope_MineInputs */

const cs_templates_use_picker_scope_mine = /** @type {(inputs: Templates_Use_Picker_Scope_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje`)
};

const en_templates_use_picker_scope_mine = /** @type {(inputs: Templates_Use_Picker_Scope_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine`)
};

/**
* | output |
* | --- |
* | "Mine" |
*
* @param {Templates_Use_Picker_Scope_MineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_scope_mine = /** @type {((inputs?: Templates_Use_Picker_Scope_MineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Scope_MineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_scope_mine(inputs)
	return cs_templates_use_picker_scope_mine(inputs)
});